import * as t from 'io-ts';

import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RPermanentlyDismissedIdsOverrides = t.intersection([
  RLastWriterWinsValue,
  t.type({
    permanentlyDismissedIds: t.record(t.string, t.boolean),
  }),
]);

export type PermanentlyDismissedIdsOverrides = t.TypeOf<typeof RPermanentlyDismissedIdsOverrides>;

export const defaultPermanentlyDismissedIdsOverrides: PermanentlyDismissedIdsOverrides = {
  ...defaultLastWriterWinsValue,
  permanentlyDismissedIds: {},
};

/*
 * Conflict resolution.
 */

export const mergePermanentlyDismissedIdsOverrides: (
  left: PermanentlyDismissedIdsOverrides,
  right: PermanentlyDismissedIdsOverrides,
) => PermanentlyDismissedIdsOverrides = mergeLastWriterWinsValue;
